import { useTenantSetting } from "./use-tenant-setting";

export function useConfig() {
  const [tenant] = useTenantSetting();

  return {
    tenant,
  };
}
